import { render, staticRenderFns } from "./PlanComparisonTable.vue?vue&type=template&id=7e183948&"
import script from "./PlanComparisonTable.vue?vue&type=script&lang=js&"
export * from "./PlanComparisonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports